module.exports = __webpack_public_path__ + "8b57b263533e544462f8e06b7397fbf2.png";